import React from 'react';
import { Outlet, Link } from "react-router-dom";
import './Menu.min.css';

const Menu = props => {

    return(
        <div id='menu'>
            
                <ul>
                    <li><Link to="/Today" > Dzisiaj </Link> <div id='today'></div></li>
                    
                    <li><Link to="/Tomorrow" >Jutro</Link> <div id='tomorrow'></div></li>
                    <li><Link to="/SevenDays" >Siedem dni</Link><div id='sevenDays'></div></li>  
                    
                </ul>
                <Outlet/>
                
            </div>
    )
}
export default Menu;